import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppVersionService {

  public get appVersion(): string { return "0.52"; }
}
